import React, {Component} from 'react';
import {Col} from "reactstrap";
import CustomerWarningForm from "./CustomerWarningForm";
import CustomerWarningList from "./CustomerWarningList";
import CustomerWarningEditModal from "./CustomerWarningEditModal";
import SweetAlert from 'react-bootstrap-sweetalert';
import {request} from "../../../helper/APIUtils";
import {showAxiosError} from "../../../helper/helper";
import CustomerWarningNoEntry from "./CustomerWarningNoEntry";

class CustomerWarningInfo extends Component {

	constructor(props) {
		super(props);
		this.state = {
			mode: 'list',
			colSize: '12',
			display: 'page',
			removeWarningAlert: null
		};

		this.setWarningTypesDropdownListSize = this.setWarningTypesDropdownListSize.bind(this);
		this.submitNewWarning = this.submitNewWarning.bind(this);
		this.setModeAsCreate = this.setModeAsCreate.bind(this);
		this.switchModeToList = this.switchModeToList.bind(this);
		this.openEditModal = this.openEditModal.bind(this);
		this.closeEditModal = this.closeEditModal.bind(this);
		this.updateWarningAndCurrentWarnings = this.updateWarningAndCurrentWarnings.bind(this);
		this.onRemoveWarning = this.onRemoveWarning.bind(this);
	}

	componentDidMount() {
		let mode = this.state.mode;

		let currentWarnings = this.props.customer.customerWarnings;
		let warningTypes = this.props.warningTypes;

		let warningTypesDropdownListSize = warningTypes.length - currentWarnings.length;

		if (currentWarnings.length === 0) {
			mode = 'intro';
		}

		this.setState({
			mode,
			currentWarnings,
			warningTypesDropdownListSize
		})
	}

	setModeAsCreate() {
		this.setState({
			mode: 'create',
			display: 'page'
		})
	}

	switchModeToList() {
		this.setState({
			mode: 'list',
		})
	}

	submitNewWarning(currentWarnings) {
		let warningTypes = this.props.warningTypes;
		let warningTypesDropdownListSize = warningTypes.length - currentWarnings.length;

		this.setState({
			mode: 'list',
			currentWarnings,
			warningTypesDropdownListSize
		}, () => {
			this.closeEditModal();
		});
		this.props.updateCustomerWarningList(currentWarnings);
	}

	setWarningTypesDropdownListSize(size) {
		this.setState({
			warningTypesDropdownListSize: size
		})
	}

	openEditModal(data, index) {
		this.setState({
			mode: 'edit',
			selectedWarning: data,
			selectedIndex: index,
			display: 'modal'
		})
	}

	closeEditModal() {
		let mode = this.state.currentWarnings.length === 0 ? 'intro' : 'list';
		this.setState({
			mode,
			selectedWarning: null,
			selectedIndex: null,
			display: 'page'
		})
	}

	updateWarningAndCurrentWarnings(updatedWarning) {
		let currentWarnings = this.props.customer.customerWarnings;
		let warningTypes = this.props.warningTypes;
		let warningOptions = this.props.warningOptions;

		let selectedWarning = currentWarnings[updatedWarning.selectedIndex];

		let warningType;
		if (updatedWarning.warningType !== null) {
			warningType = warningTypes.filter(wt => {
				return wt.recordId === updatedWarning.warningType;
			})[0];
		} else {
			warningType = selectedWarning.warningType;
		}

		let warningOption;
		if (updatedWarning.warningOption !== null) {
			warningOption = warningOptions.filter(wo => {
				return wo.recordId === updatedWarning.warningOption;
			})[0];
			if (warningOption.recordId === 1) {
				warningMail = updatedWarning.warningMail;
				warningPhone = null;
			}

			if (warningOption.recordId === 2) {
				warningMail = null;
				warningPhone = updatedWarning.warningPhone;
			}

			if (warningOption.recordId === 3) {
				warningMail = !!updatedWarning.warningMail ? updatedWarning.warningMail : selectedWarning.warningMail;
				warningPhone = !!updatedWarning.warningPhone ? updatedWarning.warningPhone : selectedWarning.warningPhone;
			}
		} else {
			warningOption = selectedWarning.warningOption;
		}

		let warningMail;
		if (updatedWarning.warningMail !== null) {
			warningMail = updatedWarning.warningMail;
		} else {
			if ((updatedWarning.warningOption === 1) || (updatedWarning.warningOption === 3)) {
				warningMail = selectedWarning.warningMail;
			} else {
				if (!updatedWarning.warningOption) {
					if (!updatedWarning.warningMail && selectedWarning.warningMail) {
						warningMail = selectedWarning.warningMail;
					} else {
						warningMail = null;
					}
				}
			}
		}

		let warningPhone;
		if (updatedWarning.warningPhone !== null) {
			warningPhone = updatedWarning.warningPhone;
		} else {
			if ((updatedWarning.warningOption === 2) || (updatedWarning.warningOption === 3)) {
				warningPhone = selectedWarning.warningPhone;
			} else {
				if (!updatedWarning.warningOption) {
					if (!updatedWarning.warningPhone && selectedWarning.warningPhone) {
						warningPhone = selectedWarning.warningPhone;
					} else {
						warningPhone = null;
					}
				}
			}
		}

		let newWarning = {};
		if (!!selectedWarning.recordId) {
			newWarning.recordId = selectedWarning.recordId;
		}
		newWarning.warningType = warningType;
		newWarning.warningOption = warningOption;
		newWarning.warningMail = warningMail;
		newWarning.warningPhone = warningPhone;

		let data = this.saveOrUpdateCustomerWarning(newWarning);

		if (data) {
			currentWarnings.splice(updatedWarning.selectedIndex, 1, newWarning);

			this.submitNewWarning(currentWarnings);
		}
	}

	async saveOrUpdateCustomerWarning(warning) {
		let params = {
			url: `/customer/saveOrUpdateCustomerWarning`,
			method: 'post',
			data: warning
		};
		let data = null;
		await request(params).then((response) => {
			data = response.data;
			return data;
		}).catch(function (error) {
			showAxiosError(error);
		});
		return data
	}

	onRemoveWarning(selection, index) {

		let selectedWarning = selection !== null ? selection : this.state.selectedWarning;

		this.setState({
			removeWarningAlert: (
				<SweetAlert showCancel warning
							confirmBtnText="Onayla"
							cancelBtnText="İptal"
							confirmBtnBsStyle="success"
							cancelBtnBsStyle="default"
							title="Emin misiniz ?"
							onConfirm={() => this.onConfirmRemoveWarning(selectedWarning, index)}
							onCancel={() => this.setState({removeWarningAlert: null})}
				>
					{'Onaylarsanız, artık bu türde bildirim almayacaksınız.'}
				</SweetAlert>
			)
		});
	}

	onConfirmRemoveWarning(selectedWarning, index) {
		let self = this;
		let params = {
			url: `/customer/removeWarning`,
			method: 'post',
			data: selectedWarning
		};
		request(params).then(() => {
			let currentWarnings = self.state.currentWarnings;
			currentWarnings.splice(index, 1);

			let warningTypes = this.props.warningTypes;
			let warningTypesDropdownListSize = warningTypes.length - currentWarnings.length;

			let mode = this.state.mode;

			if (currentWarnings.length === 0) {
				mode = 'intro';
			}

			self.setState({removeWarningAlert: null, currentWarnings, warningTypesDropdownListSize, mode});
			self.closeEditModal();

			self.props.updateCustomerWarningList(currentWarnings);
		}).catch(function (error) {
			showAxiosError(error);
		});
	}

	render() {

		const customerWarnings = this.state.currentWarnings && this.state.currentWarnings;

		return (

			<Col sm='12' className='stableFormContainer'>
				{this.state.removeWarningAlert}

				{/*NO EXISTING NOTIFICATION ENTRY*/}
				{this.state.mode === 'intro' &&
				<CustomerWarningNoEntry setModeAsCreate={this.setModeAsCreate}/>}

				{/*LIST EXISTING STUFF*/}
				{this.state.mode !== 'intro' &&
				<CustomerWarningList customerWarnings={customerWarnings} warningTypesDropdownListSize={this.state.warningTypesDropdownListSize}
									 mode={this.state.mode} setModeAsCreate={this.setModeAsCreate} openEditModal={this.openEditModal}
									 closeEditModal={this.closeEditModal} onRemoveWarning={this.onRemoveWarning}/>}

				{/*ADD NEW STUFF*/}
				{((this.state.display && this.state.display === 'page') && this.state.mode !== 'intro') &&
				<CustomerWarningForm currentWarnings={customerWarnings} warningTypes={this.props.warningTypes} warningOptions={this.props.warningOptions}
									 mode={this.state.mode} switchModeToList={this.switchModeToList} submitNewWarning={this.submitNewWarning}
									 setWarningTypesDropdownListSize={this.setWarningTypesDropdownListSize}
									 saveOrUpdateCustomerWarning={this.saveOrUpdateCustomerWarning}/>}

				{/*EDIT EXISTING STUFF*/}
				<CustomerWarningEditModal mode={this.state.mode} selectedWarning={this.state.selectedWarning} closeModal={this.closeEditModal}
										  warningTypes={this.props.warningTypes} warningOptions={this.props.warningOptions}
										  currentWarnings={customerWarnings} switchModeToList={this.switchModeToList}
										  submitNewWarning={this.submitNewWarning} setWarningTypesDropdownListSize={this.setWarningTypesDropdownListSize}
										  selectedWarning={this.state.selectedWarning} selectedIndex={this.state.selectedIndex}
										  updateWarningAndCurrentWarnings={this.updateWarningAndCurrentWarnings} onRemoveWarning={this.onRemoveWarning}/>
			</Col>
		)
	}
}

export default CustomerWarningInfo;